import '../css/standard.css'
import cloudDevelopment from './../images/cloudDevelopment.png';


const Development = () => {
  return (
    <div>
    <p className="standard-paragraph">
    <div class="container">
      <div class="image-container">
        <img src={cloudDevelopment} alt="Cloud Development" width={300}/>
      </div>
      <div class="text-container">
        <h2>Development</h2> 
        <p class="text-text">  
          Embark on a journey of innovative software development with our specialized AWS solutions. We offer end-to-end services, 
          from designing and implementing scalable architectures to ensuring optimal performance and security. Explore our comprehensive 
          software development services that encompass AWS, delivering tailored solutions to meet the evolving needs of your business.
        </p>
      </div>
    </div>

    <ul class="custom-list">
      <li><strong>Serverless Architecture:</strong> Utilize AWS Lambda and other serverless services to eliminate infrastructure management and auto-scale based on workload.</li>
      <li><strong>Infrastructure as Code (IaC):</strong> Implement IaC using AWS CloudFormation or AWS CDK for consistent, version-controlled, and repeatable infrastructure deployment.</li>
      <li><strong>Microservices:</strong> Adopt a microservices-based approach to ensure modularity and flexibility in application development and management.</li>
      <li><strong>Security:</strong> Prioritize security by applying the principle of least privilege (PoLP), using AWS IAM for access control, auditing and monitoring with AWS CloudTrail and AWS Config, and implementing encryption with AWS KMS.</li>
      <li><strong>Performance Optimization:</strong> Optimize performance with Amazon CloudFront as a CDN, Auto Scaling and Amazon ELB for load balancing, AWS Elastic Beanstalk for simplified deployment, and monitoring/logging through Amazon CloudWatch.</li>
    </ul>   
    </p> 
    </div>);
};

export default Development;
